import { createUpload } from '@mux/upchunk';

// Uploads a video file to a Mux direct-upload URL using resumable, chunked transfer
// (handles large files up to the 500MB limit). Resolves when Mux has received the file;
// transcoding then happens asynchronously and is reported via the Mux webhook.
export const uploadFileToMux = (
  uploadUrl: string,
  file: File,
  onProgress?: (percent: number) => void,
): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const upload = createUpload({ endpoint: uploadUrl, file });

    upload.on('progress', (event) => {
      const percent = typeof event.detail === 'number' ? event.detail : Number(event.detail);
      if (!Number.isNaN(percent)) {
        onProgress?.(Math.round(percent));
      }
    });

    upload.on('success', () => resolve());

    upload.on('error', (event) => {
      const detail = event.detail as { message?: string } | undefined;
      reject(new Error(detail?.message ?? 'Video upload failed.'));
    });
  });
